<template>
  <div class="spinner" v-if="isLoading()">
    <clip-loader :color="color" :size="size"></clip-loader>
  </div>
</template>

<script>
import ClipLoader from 'vue-spinner/src/ClipLoader.vue';
import { mapGetters } from 'vuex';

export default {
  name: 'spinner',
  props: {
    useCustomProperty: {
      type: Boolean,
      required: false,
    },
    loadingProperty: {
      type: Boolean,
      required: false,
    },
  },
  data: () => ({
    color: '#FF6A10',
    size: '70px',
  }),
  methods: {
    isLoading() {
      return this.useCustomProperty ? this.loadingProperty : this.loading;
    },
  },
  computed: {
    ...mapGetters({
      loading: 'loadingData',
    }),
  },
  components: {
    ClipLoader,
  },
};
</script>
